import { render, staticRenderFns } from "./glpNotUnloaded.vue?vue&type=template&id=ab9e4562&scoped=true"
import script from "./glpNotUnloaded.vue?vue&type=script&lang=js"
export * from "./glpNotUnloaded.vue?vue&type=script&lang=js"
import style0 from "./glpNotUnloaded.vue?vue&type=style&index=0&id=ab9e4562&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9e4562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab9e4562')) {
      api.createRecord('ab9e4562', component.options)
    } else {
      api.reload('ab9e4562', component.options)
    }
    module.hot.accept("./glpNotUnloaded.vue?vue&type=template&id=ab9e4562&scoped=true", function () {
      api.rerender('ab9e4562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/cmp/glpNotUnloaded.vue"
export default component.exports